<section>
    <div class="header">
        <div>
            <app-badge text="Cómo Construimos"></app-badge>
            <h2 class="title">Nuestra forma de construir</h2>
        </div>
        <p class="description" > Con más de 30 años de experiencia, hemos consolidado relaciones duraderas que forman parte de nuestra historia y de un futuro compartido. </p>
    </div>
    <div class="content">
        <div class="topic" *ngFor="let topic of topis; trackBy: trackElement">
            <div class="icon">
                <lucide-icon [name]="topic.icon" [size]="75"></lucide-icon>
            </div>
            <h3 class="topic-title">{{ topic.title }}</h3>
            <p class="topic-description">{{ topic.description }}</p>
        </div>
    </div>
</section>